import * as dotProp from 'dot-prop-immutable';

import {
  createReducer,
  getArrayAfterAsyncCall,
  updateArrayItemAfterAsyncCall,
} from '@topconagriculture/frontend-utils';

import {
  createAutomatedReports,
  deleteAutomatedReports,
  getAutomatedReportsList,
  updateAutomatedReports,
} from './automatedReports.actions';
import { AutomatedReport } from './automatedReports.types';

export type AutomatedReportsState = AutomatedReport[];

const initialState: AutomatedReportsState = [];

const automatedReportsReducer = createReducer(initialState, {
  [getAutomatedReportsList.done.type]: (
    state: AutomatedReportsState,
    action: ReturnType<typeof getAutomatedReportsList.done>,
  ) => getArrayAfterAsyncCall(state, action),
  [createAutomatedReports.done.type]: (
    state: AutomatedReportsState,
    action: ReturnType<typeof createAutomatedReports.done>,
  ) => [...state, action.payload.result],
  [updateAutomatedReports.done.type]: (
    state: AutomatedReportsState,
    action: ReturnType<typeof updateAutomatedReports.done>,
  ) => updateArrayItemAfterAsyncCall<AutomatedReport>(state, action),
  [deleteAutomatedReports.done.type]: (
    state: AutomatedReportsState,
    action: ReturnType<typeof deleteAutomatedReports.done>,
  ) => {
    const id = action.payload.params.id;
    const indexFound = state.findIndex((report) => report.id === id);
    return dotProp.delete(state, indexFound);
  },
});

export default automatedReportsReducer;
